// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"587":"a8712d7d","787":"bcbf1bec","871":"6ecfc287"}[chunkId] + ".chunk.js";
};